import React, { Suspense, useEffect, useState } from 'react';

// Dynamic import wrapper to isolate potential inheritance issues and load after React fully initialized
const CKEditorModule = () => import('ckeditor4-react');

export default function LazyCKEditor(props) {
  const [Comp, setComp] = useState(null);
  useEffect(() => {
    let mounted = true;
    CKEditorModule()
      .then(mod => {
        if (mounted) setComp(() => mod.default || mod.CKEditor || mod);
      })
      .catch(err => {
        console.error('[LazyCKEditor] Failed to load CKEditor', err);
      });
    return () => { mounted = false; };
  }, []);
  if (!Comp) return <div>Loading editor...</div>;
  return <Comp {...props} />;
}
